const isDevEnv = () => {
  const env = process.env.REACT_APP_ENV
  return env && env !== 'undefined'
    ? ['local', 'qa', 'dev', 'stg'].includes(env)
    : true
}

export default isDevEnv
